import styled from "styled-components";
import { getColor, getColorWithAlpha, responsive } from "~/helpers/style";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  gap: 12px;

  ${responsive("mobileL")} {
    flex-direction: row;
  }

  & label {
    display: flex;
    align-items: center;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 12px;
`;

export const LabelImage = styled.img`
  width: 35px;

  ${responsive("mobileL")} {
    width: 60px;
  }
`;

export const Label = styled.label<{ checked: boolean }>`
  && {
    width: 100%;
    color: ${getColor("text")};
    font-size: 16px;
    flex-direction: column;
    align-items: flex-start;
    line-height: 20px;
    margin-bottom: 0;
    font-weight: ${(props) => (props.checked ? "600" : "500")};
  }
`;

export const LabelDescription = styled.span<{ checked: boolean }>`
  width: 100%;
  color: ${(props) =>
    props.checked ? getColor("text") : getColorWithAlpha("text", 0.4)};
  font-size: 10px;
  line-height: 182%;
  margin-bottom: 0;
  font-weight: 400;
`;
